import api from "../../../utils/api";

export const createTicket = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/tickets/", payload);
  return res.data;
};

export const readTicket = async (id) => {
  if (!id) throw new Error("Missing or invalid ID for ticket");
  const res = await api.get(`/tickets/${id}`);
  return res.data;
};

export const readTickets = async (params) => {
  const res = await api.get("/tickets", { params });
  return res.data;
};

export const ReadTicketSources = async () => {
  const res = await api.get("/ticket_sources");
  return res.data;
};

export const ReadTicketStatuses = async () => {
  const res = await api.get("/ticket_statuses");
  return res.data;
};

export const updateTicket = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for ticket");
  const res = await api.put(`/tickets/${payload.public_id}`, payload);
  return res.data;
};

export const deleteTicket = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for ticket!");
  return await api.delete(`/tickets/${publicId}`);
};
